import React, { useState } from "react";
import {
  Box,
  Link,
  List,
  ListItem,
  Modal,
  Paper,
  Stack,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { Colors } from "@src/gatsby-theme-material-ui-top-layout/colors-twentyfive";
import { useWebsiteStore } from "@src/hooks/useWebsiteStore";
import { getTwentyFiveTheme } from "@src/gatsby-theme-material-ui-top-layout/theme";
import HubspotAiChallengeForm from "../Hubspot/AiChallengeForm";
import ShareButtons from "../ShareButtons";

const listItemStyle = {
  display: "list-item",
  "::marker": { color: Colors.PrimaryContrast },
  textDecoration: "underline",
  fontSize: "14px",
  paddingY: "0px",
};

const AiChallengeRegisterModal = () => {
  const [done, setDone] = useState(false);
  const open = useWebsiteStore((state) => state.modalAiChallengeRegisterOpen);
  const handleClose = useWebsiteStore(
    (state) => state.actions.closeModalAiChallengeRegister,
  );

  return (
    <ThemeProvider theme={getTwentyFiveTheme}>
      <Modal
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        keepMounted={true}
      >
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "100%",
            maxWidth: "450px",
            transform: "translate(-50%, -50%)",
            padding: { xs: "16px", md: "32px" },
            backgroundColor: Colors.BackgroundBody,
            borderRadius: "30px",
          }}
        >
          <Stack
            gap={3}
            sx={{
              justifyItems: "center",
              textAlign: "center",
            }}
          >
            {done ? (
              <Stack spacing={4}>
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      color: Colors.InfoLight,
                    }}
                  >
                    Thanks for registering!
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "14px",
                      marginTop: "24px",
                    }}
                  >
                    A confirmation will be sent to you email.
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      color: Colors.InfoLight,
                      width: "90%",
                      marginX: "auto",
                      lineHeight: "normal",
                    }}
                  >
                    Invite others to play!
                  </Typography>

                  <ShareButtons
                    pathToShare={`landing/ai-escape-room/`}
                    titleToShare={"Pangea AI Escape Room Challenege"}
                    blurbToShare={
                      "Can you outsmart the AI? Play the Pangea Prompt Injection Challenge to top the leaderboard!"
                    }
                    mailtoBodyTemplate="I've registered to play the Pangea AI Escape Room Challenge, check it out: <url>"
                    articleTitleTemplate="I'm inviting you to play the Pangea AI Escape Room Challenge"
                    utmCampaign="ai-challenge"
                    shareTypeText=""
                    buttonStyles={{
                      background: Colors.PrimaryGradient,
                    }}
                    containerStyles={{
                      justifyContent: "center",
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    textAlign: "center",
                    width: "80%",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: "left",
                    }}
                  >
                    <b>Resources to get you started:</b>

                    <List
                      sx={{
                        listStyleType: "disc",
                        listStylePosition: "inside",
                      }}
                    >
                      <ListItem sx={listItemStyle}>
                        <Link
                          href="/blog/understanding-and-mitigating-prompt-injection-attacks/"
                          target="_blank"
                        >
                          Understanding and Mitigating Prompt Injection Attacks
                        </Link>
                      </ListItem>
                      <ListItem sx={listItemStyle}>
                        <Link
                          href="/securebydesign/aiapp-threats-inference/"
                          target="_blank"
                        >
                          About AI Prompt and Inference Pipeline Threats
                        </Link>
                      </ListItem>
                    </List>
                  </Typography>
                </Box>
              </Stack>
            ) : (
              <>
                <Typography
                  variant="h4"
                  sx={{
                    color: Colors.InfoLight,
                  }}
                >
                  Reserve your spot
                </Typography>

                <Typography variant="body2">
                  Compete in Pangea's Prompt Injection Challenge.
                </Typography>

                {open ? (
                  <HubspotAiChallengeForm
                    formId="008d960e-9015-48e1-acad-ce00d09fe97e"
                    hideUntilLoaded={true}
                    rawCSSStyles={{
                      $form: {
                        height: "auto",
                        paddingTop: "20px",
                      },
                      input: {
                        backgroundColor: Colors.BackgroundBody,
                        borderRadius: "10px",
                        border: `solid 1px #62758D`,
                        padding: "15px 20px",
                        color: Colors.PrimaryContrast,
                      },
                      label: {
                        display: "none",
                      },
                      'input[type="submit"]': {
                        color: Colors.PrimaryContrast,
                        backgroundColor: Colors.PrimaryGradient,
                      },
                    }}
                    successCallback={(_form: any) => {
                      setDone(true);
                    }}
                  />
                ) : (
                  ""
                )}
              </>
            )}
          </Stack>
        </Paper>
      </Modal>
    </ThemeProvider>
  );
};

export default AiChallengeRegisterModal;
